module.exports = __webpack_public_path__ + "img/indicator3a_v2.5db28fc7.svg";